import toolsClient from "@/api/toolsClient";

export const getPortalLiveStats = async () => {
  const response = await toolsClient.get(`portal/stats/live`);
  return response.data;
};
